"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'profession.form.back': 'Wstecz',
    'profession.form.name.label': 'Nazwa',
    'profession.form.name.placeholder': 'Nazwa zawodu',
    'profession.form.branch.label': 'Branża',
    'profession.form.branch.placeholder': 'Wybierz branżę',
    'profession.form.description.label': 'Opis',
    'profession.form.description.placeholder': 'Wprowadź opis zawodu',
    'profession.form.common.label': 'Wspólny',
    'profession.form.image.label': 'Obraz',
    'profession.form.knowledge.label': 'Wpisy Wiedzy',
    'profession.form.knowledge.title': 'Wpisy Wiedzy',
    'profession.form.steps.title': 'Kroki',
    'profession.form.steps.label': 'Wybierz Kroki',
    'profession.form.submit.label': 'Wyślij',
    'profession.form.active.label': 'Aktywny',
    'profession.form.knowledge.placeholder': 'Szukaj wpisów wiedzy...',
    'profession.form.branches.load.error': 'Błąd ładowania branż',
    'profession.form.steps.load.error': 'Błąd ładowania kroków',
    'profession.form.load.error': 'Błąd ładowania zawodu',
    'profession.form.update.success': 'Zawód zaktualizowany pomyślnie',
    'profession.form.action.success': 'Zawód',
    'profession.form.action.error': 'Zawód nie mógł zostać',
    'profession.form.action.failed': 'Błąd w',
    'profession.form.update': 'aktualizacji',
    'profession.form.create': 'tworzeniu',
};
